import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=3ebef181&scoped=true"
import script from "./SwitchInput.vue?vue&type=script&lang=ts"
export * from "./SwitchInput.vue?vue&type=script&lang=ts"
import style0 from "./SwitchInput.vue?vue&type=style&index=0&id=3ebef181&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebef181",
  null
  
)

export default component.exports